import _ from "lodash";
import React from "react";
import { Button, Modal, Tabs } from "@toddle-edu/ds-web";
import useI18n from "Hooks/UseI18n";
import { useDispatch } from "Hooks/useDispatch";
import { createPollMessage } from "MessagingV2/modules/MessagingModule";

import classes from "./CreatePollModal.scss";
import PollsQuestionAndOptions from "./PollQuestionAndOptions";
import PollSettings from "./PollSettings";
import moment from "moment";
import { generateRandomId } from "Utils/GenerateRandomId";

const POLL_TABS = {
  POLL: "poll",
  SETTINGS: "settings",
};

const getTabOptions = ({ t }) => [
  {
    label: t("common:overview"),
    value: POLL_TABS.POLL,
  },
  {
    label: t("common:settings"),
    value: POLL_TABS.SETTINGS,
  },
];

const styles = {
  tabStyle: {
    paddingBottom: "8px",
  },
  modalBodyStyle: {
    padding: "0px",
    overflow: "hidden",
  },
};

const ChannelArchiveModal = props => {
  const { chatId, onCloseModal } = props;

  const dispatch = useDispatch();
  const [poll, setPoll] = React.useState({
    question: "",
    options: [
      {
        id: generateRandomId(),
      },
      {
        id: generateRandomId(),
      },
    ], // by default 2 options
  });

  const [settings, setSettings] = React.useState(() => {
    // two weeks from now
    const expiresAt = moment().add(2, "weeks").toDate();
    return {
      expiresAt,
      isResultPublic: true,
      isMultipleVoteAllowed: true,
      isResponseEditAllowed: true,
    };
  });

  const [currentTab, setCurrentTab] = React.useState("poll");

  const { t } = useI18n(["common"]);

  const onSend = () => {
    dispatch(
      createPollMessage({
        chatId,
        question: poll.question,
        options: _.map(poll.options, option => ({
          label: option.label,
          emoji: option.icon,
        })),
        settings,
      })
    );
    onCloseModal();
  };

  const optionsWithLabels = _.filter(poll.options, option => option.label);

  return (
    <Modal
      dsVersion={"2.0"}
      height="598px"
      hasOverlay
      width="480px"
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      onClose={onCloseModal}
      isOpen
    >
      <Modal.Header title={t("common:create_a_poll")} isClosable={true} />

      <Modal.Body style={styles.modalBodyStyle}>
        <div className={classes.modalBodyContainer}>
          <div className={classes.tabsContainer}>
            <Tabs
              dsVersion="2.0"
              options={getTabOptions({ t })}
              onChange={setCurrentTab}
              value={currentTab}
              containerStyle={styles.tabStyle}
            />
          </div>
          <div className={classes.modalBodyContent}>
            {currentTab === POLL_TABS.POLL ? (
              <PollsQuestionAndOptions poll={poll} setPoll={setPoll} />
            ) : (
              <PollSettings settings={settings} setSettings={setSettings} />
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className={classes.footerContainer}>
          <Button
            dsVersion="2.0"
            variant="progressive"
            onClick={onSend}
            disabled={
              !poll.question ||
              _.isEmpty(poll.options) ||
              _.size(optionsWithLabels) < 2
            }
          >
            {t("common:send")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ChannelArchiveModal;
